/**
 * LoadingSpiral — replaces all pulsing dot loading states.
 * A small spiral arc that rotates continuously, consistent with the spiral metaphor.
 */

interface LoadingSpiralProps {
  size?: number
  label?: string
}

export default function LoadingSpiral({ size = 24, label }: LoadingSpiralProps) {
  const r = size * 0.375
  const cx = size / 2
  const circumference = 2 * Math.PI * r
  const arc = circumference * 0.7  // 70% arc visible, 30% gap

  return (
    <div className="flex items-center gap-2.5">
      <div
        aria-hidden="true"
        style={{
          width: size,
          height: size,
          flexShrink: 0,
          animation: 'spiralSpin 1s linear infinite',
        }}
      >
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          {/* Ghost ring */}
          <circle cx={cx} cy={cx} r={r} fill="none" stroke="#E4D5EE" strokeWidth={size * 0.1} />
          {/* Animated arc */}
          <circle
            cx={cx}
            cy={cx}
            r={r}
            fill="none"
            stroke="#9B72C0"
            strokeWidth={size * 0.1}
            strokeLinecap="round"
            strokeDasharray={`${arc} ${circumference - arc}`}
            strokeDashoffset={circumference * 0.25}
          />
        </svg>
      </div>
      {label && (
        <span className="text-xs" style={{ color: '#6B5F7A' }}>{label}</span>
      )}
      <style>{`@keyframes spiralSpin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
